<template>
    <div :class="'form-check formly-input checkbox-input mt-4' + (field.templateOptions.wrapperClasses ? field.templateOptions.wrapperClasses : '')">
        <input type="checkbox" :id="field.key" class="form-check-input" v-model="model[field.key]">
        <label :for="field.key" class="form-check-label" v-html="field.templateOptions.label"></label>
        <error-display :form="form" :field="field.key"></error-display>
    </div>
</template>

<script>
  import baseField from 'vue-formly-bootstrap/src/fields/baseField';

  export default {
    name: 'CheckboxField',
    mixins: [baseField],
  };
</script>

<style scoped>
    .checkbox-input {
        min-height: 72px;
    }
</style>
